export const rp = (n) => "Rp " + Math.round(Number(n) || 0).toLocaleString("id-ID");

const TZ = "Asia/Jakarta";
export const fmtDate = (iso) =>
  iso ? new Intl.DateTimeFormat("id-ID", { timeZone: TZ, day: "numeric", month: "short", year: "numeric" }).format(new Date(iso)) : "-";
export const fmtDateTime = (iso) =>
  iso
    ? new Intl.DateTimeFormat("id-ID", { timeZone: TZ, day: "numeric", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit" }).format(new Date(iso)) + " WIB"
    : "-";

export const toInputWIB = (iso) => (iso ? new Date(new Date(iso).getTime() + 7 * 3600e3).toISOString().slice(0, 16) : "");
export const fromInputWIB = (v) => (v ? `${v}:00+07:00` : null);
export const todayWIB = (offsetDays = 0) => new Date(Date.now() + 7 * 3600e3 + offsetDays * 864e5).toISOString().slice(0, 10);

export const PO_STATUS = {
  coming_soon: { label: "Coming Soon", cls: "bg-white text-neutral-900 border-neutral-900" },
  open: { label: "PO Dibuka", cls: "bg-emerald-500 text-white border-emerald-700" },
  closing_soon: { label: "PO Segera Ditutup", cls: "bg-[#ff7a00] text-white border-orange-800" },
  closed: { label: "PO Ditutup", cls: "bg-neutral-600 text-white border-neutral-800" },
  in_transit: { label: "Dalam Pengiriman", cls: "bg-[#1d4fa8] text-white border-blue-900" },
  arrived: { label: "Tiba di Toko", cls: "bg-teal-600 text-white border-teal-800" },
};

export const ORDER_STATUS = {
  menunggu_konfirmasi: { label: "Menunggu Konfirmasi", cls: "bg-amber-100 text-amber-900" },
  menunggu_pembayaran: { label: "Menunggu Pembayaran", cls: "bg-orange-100 text-orange-900" },
  menunggu_verifikasi: { label: "Menunggu Verifikasi", cls: "bg-sky-100 text-sky-900" },
  diproses: { label: "Diproses", cls: "bg-blue-100 text-blue-900" },
  siap_diambil: { label: "Siap Diambil", cls: "bg-teal-100 text-teal-900" },
  dalam_pengiriman: { label: "Dalam Pengiriman", cls: "bg-indigo-100 text-indigo-900" },
  selesai: { label: "Selesai", cls: "bg-emerald-100 text-emerald-900" },
  dibatalkan: { label: "Dibatalkan", cls: "bg-red-100 text-red-800" },
};

export const PAYMENT_STATUS = {
  belum_bayar: { label: "Belum Bayar", cls: "bg-neutral-100 text-neutral-800" },
  dp_dibayar: { label: "DP / Sebagian Dibayar", cls: "bg-amber-100 text-amber-900" },
  lunas: { label: "Lunas", cls: "bg-emerald-100 text-emerald-900" },
  dikembalikan: { label: "Dikembalikan", cls: "bg-red-100 text-red-800" },
};

export const PAYMENT_KIND = { dp: "DP", pelunasan: "Pelunasan", penuh: "Pembayaran Penuh", refund: "Pengembalian Dana" };

export const dpLabel = (po) =>
  po.dp_type === "percent" ? `DP ${po.dp_value}%` : po.dp_type === "fixed" ? `DP ${rp(po.dp_value)}` : "Tanpa DP";

export const waLink = (number, text) => `https://wa.me/${number}?text=${encodeURIComponent(text)}`;
export const waContacts = (s) => [
  { label: s.whatsapp_label || "Admin 1", number: s.whatsapp, display: s.whatsapp_display || s.whatsapp },
  ...(s.extra_whatsapp || []).map((c) => ({ ...c, display: c.display || c.number })),
].filter((c) => c.number);
